import React, { Component } from "react";
import { Upload } from '@progress/kendo-react-upload';
import { Button } from '@progress/kendo-react-buttons';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import axios from 'axios';


class BulkUploadForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: this.props.user,
            files: [],
            uploading: false,
            altFiles: '',
            title: '',
            expiration: '',
            initialLoad: true,
            householdGroupCheckbox: false,
            groups: [],
            groupsToAdd: [],
            uploadDescription: 'bulkstatementfile',
            uploadKeyFolder: 'bulkstatementzipfiles'


        }


        this.onAdd = this.onAdd.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.clearState = this.clearState.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getGroups = this.getGroups.bind(this);
        this.onHouseholdGroupsChange = this.onHouseholdGroupsChange.bind(this)
        this.onProgress = this.onProgress.bind(this);

    }

    componentDidMount() {
        this.getGroups();
    }

    useEffect(){
        window.addEventListener('beforeunload', this.displayAlertOnClose);
        return () => {
          window.removeEventListener('beforeunload', this.displayAlertOnClose);
        }
      }
    
      displayAlertOnClose = (event) => {   
        event.preventDefault();
        event.returnValue = "";
        return "";
      }

    getGroups() {
        //this.setState({ loading: true });
        var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
        axios.get("api/householdgroups?company=" + this.props.company, { headers }).then(response => {
            if (response.data.code === 200) {
                console.log(response.data)
                this.setState({ groups: response.data.groups, loading: false });
            }
            else {
                alert("An error occured while fetching the user groups.");
                this.setState({ loading: false });
            }
        }).catch(error => console.log(error));
    }

    onAdd = (event) => {
        this.setState({ restrictionHit: false });

        const invalidFiles = event.affectedFiles.filter(f => f.validationErrors && f.validationErrors.length > 0);
        if (invalidFiles.length > 0) { this.setState({ restrictionHit: true }); }

      const newFiles = event.newState.map(f => ({
        ...f,
        status: "selected",
        progress: 0,
      }));
      this.setState({ files: [...newFiles] });
    };

    startUpload = async () => {
        this.useEffect();
        this.setState({uploading: true})
      const { company, idToken } = this.props;
      const headers = { authorization: `Bearer ${idToken}` };
      for (let file of this.state.files) {
        const rawFile = file.getRawFile();
        try {
          // 2.1 Get presigned URL from backend (with Authorization)
          const { data } = await axios.get(`/api/fileuploadDirect`, {
            params: { company, type: rawFile.type, keyFolder: this.state.uploadKeyFolder },
            headers // only for backend request
          });

          // 2.2 Upload directly to S3 (NO Authorization header here)
          await axios.put(data.url, rawFile, {
            headers: { "Content-Type": rawFile.type },
            onUploadProgress: e => {
              const percent = Math.round((e.loaded * 100) / e.total);
              this.setState(prev => ({
                files: prev.files.map(f =>
                  f.uid === file.uid ? { ...f, progress: percent } : f
                )
              }));
            }
          });

          // 2.3 Mark file as uploaded
          this.setState(prev => ({
            files: prev.files.map(f =>
              f.uid === file.uid
                ? { ...f, progress: 100, status: "uploaded" }
                : f
            )
          }));

        let householdGroupList="";
        let groupList = [];

        if (this.state.groupsToAdd.length > 0)
        {
            this.state.groupsToAdd.forEach(group => {
                groupList.push(group.name.toString());
              });
             householdGroupList = groupList.join('[]');
            householdGroupList='[]' + householdGroupList + '[]';
        }
        

        var payload = { 
            company: company,
            uniqueName: data.key,
            originalName: file.name,
            description: this.state.uploadDescription,
            uploadedBy: this.props.user,
            groups: householdGroupList
        };

        axios.post('api/fileInfoDirect', payload, { headers }).then(response => {
            if (response.data.code === 200) {
                this.setState({ files: [], uploading: false });
                alert("File is currently processing. You will receive an email notification when complete.");
                window.removeEventListener('beforeunload', this.displayAlertOnClose);
            }
            else {
                this.setState({ files: [], uploading: false });
                alert("Error processing file.");
                window.removeEventListener('beforeunload', this.displayAlertOnClose);
            }
        })
        .catch((e) => {
                console.error(e);
                this.setState({ files: [], uploading: false });
                window.removeEventListener('beforeunload', this.displayAlertOnClose);
            });

        } catch (err) {
          console.error("Upload failed:", err);
          alert("Upload failed");
          this.setState(prev => ({
            files: prev.files.map(f =>
              f.uid === file.uid ? { ...f, status: "failed" } : f
            )
          }));
          this.setState({uploading: false});
          window.removeEventListener('beforeunload', this.displayAlertOnClose);
        }
      }
    };

    onRemove(event, isAlt) {
        this.setState({
            files: event.newState
        });
    }

    onClear = (e) => {
        this.setState({ files: [] });
    }



    onBeforeUpload = (event) => {
        //define some additional fields to pass though Upload object
        event.additionalData.username = this.props.user;
        event.additionalData.company = this.props.company;
        event.additionalData.uploadedBy = this.props.uploadUser.user;
        event.additionalData.type = 'bulkStatementZIPFile';
        event.additionalData.notifyUsers = false;//just set for now
        event.additionalData.description = 'bulkstatementfile';
        event.additionalData.uploadedBy = this.props.user;
        event.additionalData.useHouseholdFolders = false;
        this.setState({ initialLoad: false });
        this.useEffect();

    }

    onBeforeHouseholdGroupUpload = (event) => {
        //get the list of household groups
        var householdGroupList="";
        
        

        if (this.state.groupsToAdd.length > 0)
        {
            var groupList = [];
            this.state.groupsToAdd.forEach(group => {
                groupList.push(group.name.toString());
              });
             householdGroupList = groupList.join('[]');
        }
        householdGroupList='[]' + householdGroupList + '[]';

        //define some additional fields to pass though Upload object
        event.additionalData.username = this.props.user;
        event.additionalData.company = this.props.company;
        event.additionalData.uploadedBy = this.props.uploadUser.user;
        event.additionalData.groups = householdGroupList;
        event.additionalData.type = 'householdGroupFiles';
        event.additionalData.notifyUsers = false;//just set for now
        event.additionalData.description = 'householdgroupfiles';
        event.additionalData.uploadedBy = this.props.user;
        event.additionalData.useHouseholdFolders = false;
        this.setState({ initialLoad: false });
        this.useEffect();

    }


    onStatusChange(event) {

    }



    clearState = (e) => {
        this.setState({
            title: '',
            altFiles: '',
            files: [],
            expiration: '',
            initialLoad: true,
            groupsToAdd: []
        });

    }

    handleChange = (event) => {
        this.setState({ 
            householdGroupCheckbox: !this.state.householdGroupCheckbox,
            files:[],
            groupsToAdd: [],
            uploadDescription: event.target.checked ? 'householdgroupfiles' : 'bulkstatementfile',
            uploadKeyFolder: event.target.checked ? 'householdgroupfiles' : 'bulkstatementzipfiles',
        });
    }


    onHouseholdGroupsChange = (e)=>{
        this.setState({
            groupsToAdd:e.target.value,
        });

      }

    onProgress(event) {
        this.setState({ files: event.newState });
        if (event.newState && event.newState.length > 0 && event.newState[0].progress === 100 && !this.state.initialLoad) {
            alert("File is currently processing. You will receive an email notification when complete.");
            this.setState({ files: [], initialLoad: true });
            window.removeEventListener('beforeunload', this.displayAlertOnClose);
        }
    }


    render() {
        return (

            <div className="bulkDocUpload">


                <div className="content">
                    {this.state.groups.length > 0 &&
                        <label>
                            <input type="checkbox" checked={this.state.householdGroupCheckbox} onChange={this.handleChange} label={'Bulk Upload to Household Groups'} />Upload to a specific list of household groups
                        </label>
                    }
                    {!this.state.householdGroupCheckbox && <>
                        <h3>Instructions:
                        <br /> Upload a zip file containing files to be loaded into the Staged Documents area.
                        </h3>
                        You will be emailed when the ZIP file has been processed and is ready for review in the "Staged Documents" tab.
                        <br /> <br />
                        <div>Please select a .zip file to upload (5GB maximum filesize):</div>

                        {/* {this.state.initialLoad === true && */}
                            <div className="bulkDocUpload">
                            <Upload batch={true}
                                autoUpload={false}
                                multiple={false}
                                files={this.state.files}
                                onAdd={(e) => this.onAdd(e)}
                                onRemove={(e) => this.onRemove(e)}
                                onBeforeUpload={this.onBeforeUpload}
                                onStatusChange={(e) => { this.onStatusChange(e) }}
                                onProgress={(e) => this.onProgress(e)}
                                saveUrl=""
                                removeUrl=""
                                showFileList={true}
                                saveHeaders={{ 'authorization': 'Bearer '.concat(this.props.idToken) }}
                                restrictions={{
                                    maxFileSize: 5368709120,
                                    allowedExtensions: ['.zip']
                                }}
                            />
                            {this.state.files.length > 0 && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end", // right-align
                                        border: "1px solid #ccc",   // light grey border
                                        padding: "8px",
                                        marginTop: "4px",
                                        width: '49%'
                                    }}
                                >
                                    <Button
                                        themeColor="light"
                                        fillMode="solid"
                                        style={{ marginRight: "8px" }}
                                        disabled={this.state.uploading}
                                        onClick={this.onClear}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        themeColor="primary"
                                        fillMode="solid"
                                        disabled={this.state.uploading || this.state.restrictionHit}
                                        onClick={this.startUpload}
                                    >
                                        Upload
                                    </Button>
                                </div>
                            )}
                            </div>
                        {/* } */}
                    </>}
                    {this.state.householdGroupCheckbox && <>

                        <h3>Instructions:
                        <br />Select the Household Group(s), select the file and then click upload.
                        </h3>
                        You will receive an email when the file has been processed and is ready for review on the "Staged Documents" tab.
                        <br /> <br />
                        Select Household Group(s):
                        <MultiSelect
                            data={this.state.groups}
                            textField="name"
                            onChange={this.onHouseholdGroupsChange}
                        />
                        <br /> <br />
                        <div>Please select a file to upload for the selected group(s):</div>

                        {/* {this.state.initialLoad === true && */}
                            <div className="bulkDocUpload">
                            <Upload batch={true}
                                autoUpload={false}
                                showActionButtons={this.state.files.length > 0 && this.state.groupsToAdd.length > 0}
                                multiple={true}
                                files={this.state.files}
                                onAdd={(e) => this.onAdd(e)}
                                onRemove={(e) => this.onRemove(e)}
                                onBeforeUpload={this.onBeforeHouseholdGroupUpload}
                                onStatusChange={(e) => { this.onStatusChange(e) }}
                                onProgress={(e) => this.onProgress(e)}
                                saveUrl=""
                                removeUrl=""
                                showFileList={true}
                                saveHeaders={{ 'authorization': 'Bearer '.concat(this.props.idToken) }}
                                restrictions={{
                                    maxFileSize: 5368709120,
                                }}
                            />
                            {this.state.files.length > 0 && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end", // right-align
                                        border: "1px solid #ccc",   // light grey border
                                        padding: "8px",
                                        marginTop: "4px",
                                        width: '49%'
                                    }}
                                >
                                    <Button
                                        themeColor="light"
                                        fillMode="solid"
                                        style={{ marginRight: "8px" }}
                                        disabled={this.state.uploading}
                                        onClick={this.onClear}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        themeColor="primary"
                                        fillMode="solid"
                                        disabled={this.state.uploading || this.state.restrictionHit}
                                        onClick={this.startUpload}
                                    >
                                        Upload
                                    </Button>
                                </div>
                            )}
                            </div>
                    </>}


                    {this.state.initialLoad === false &&
                        <h3 style={{ color: 'red' }} >
                            <br /> File is being uploaded, please wait for it to complete.
                    <br /> Larger ZIP files may take a few minutes to upload.
                    </h3>
                    }

                </div>
            </div>


        );


    };

}

export default BulkUploadForm;